import { useEffect, useRef } from "react";
import { useI18n } from "../i18n";

// AdSense slot. Loads adsbygoogle once when a valid publisher client id is provided
// via REACT_APP_ADSENSE_CLIENT (e.g. "ca-pub-XXXXXXXXXXXXXXXX").
// If no client id is configured, renders a "Sponsored" placeholder so layout stays intact.
const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
let scriptInjected = false;

function injectScript() {
  if (scriptInjected || typeof document === "undefined") return;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  document.head.appendChild(s);
  scriptInjected = true;
}

export default function AdSlot({ slotId, format = "auto", layout = "banner", className = "" }) {
  const { t, lang } = useI18n();
  const ref = useRef(null);

  useEffect(() => {
    if (!CLIENT || !slotId) return;
    injectScript();
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) { console.warn("adsbygoogle push failed", err); }
  }, [slotId]);

  const testid = `ad-slot-${layout}`;

  if (!CLIENT || !slotId) {
    // Beautiful placeholder — labelled as sponsored
    return (
      <div
        data-testid={testid}
        className={`relative rounded-2xl border border-dashed border-[#E6DED3] bg-[#F3EDE4]/50 text-center py-3 px-4 flex items-center justify-center gap-3 ${className}`}
      >
        <span className="text-[10px] uppercase tracking-widest bg-[#1C1917] text-[#FAF7F2] px-2 py-0.5 rounded-full">
          {t("sponsored")}
        </span>
        <span className="text-xs text-[#78716C]">
          {lang === "ar"
            ? "منطقة إعلانية — ستُعرض إعلانات Google هنا بعد تفعيل الحساب"
            : lang === "fr"
              ? "Zone publicitaire — les annonces Google s'afficheront ici après activation"
              : "Ad zone — Google ads will appear here once your account is active"}
        </span>
      </div>
    );
  }

  return (
    <div className={className} data-testid={testid}>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={CLIENT}
        data-ad-slot={slotId}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
